import * as THREE from 'three';

export const AxisColors = {
  X: '#00ff00',
  Y: '#ff0000',
  Z: '#0000ff',
}
// axis colors
export const ThreeAxisColors = {
    X: new THREE.Color(0x00ff00),
    Y: new THREE.Color(0xff0000),
    Z: new THREE.Color(0x0000ff),
};

export const ThreeAxisMaterials = {
    X: new THREE.MeshBasicMaterial({ color: ThreeAxisColors.X, depthWrite: false, depthTest: false }),
    Y: new THREE.MeshBasicMaterial({ color: ThreeAxisColors.Y, depthWrite: false, depthTest: false }),
    Z: new THREE.MeshBasicMaterial({ color: ThreeAxisColors.Z, depthWrite: false, depthTest: false }),
}